<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-left-panel :span="12">
        <el-button icon="el-icon-plus" type="primary" @click="handleEdit">
          新增配置
        </el-button>
      </vab-query-form-left-panel>
    </vab-query-form>

    <el-table v-loading="listLoading" border :data="list">
      <el-table-column align="left" label="序号" width="55">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="标题"
        prop="title"
        show-overflow-tooltip
      />
      <el-table-column align="left" label="是否必填" show-overflow-tooltip>
        <template #default="{ row }">
          <el-tag v-if="row.require == 1" type="warning">必填</el-tag>
          <el-tag v-if="row.require == 0">选填</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="创建日期"
        prop="created"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ moment(row.created).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <!-- <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="150px"
      >
        <template #default="{ row }">
          <el-button type="text" @click="handleEdit(row)">修改</el-button>
          <el-button type="text" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column> -->
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <edit ref="edit" @fetch-data="fetchData" />
  </div>
</template>

<script>
import moment from 'moment'
import { setupConfig,getConfig } from '@/api/apartment'
import Edit from './edit'
export default {
  name: 'Setup',
  components: {Edit },
  data() {
    return {
      moment,
      list: [],
      listLoading: true,
    }
  },
  watch: {
    $route(to, from) {
      if (to.path == '/apartment/setup') {
        this.fetchData()
      }
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    handleEdit(row) {
      this.$refs['edit'].showEdit(row)
    },
    async fetchData() {
      this.listLoading = true
      const res = await getConfig({key:'APARTMENT'})
      this.list = res.basic&&res.basic.orderExtraInfo || []
      this.listLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.avatar {
  width: 40px;
  height: 40px;
}
</style>
